import React from 'react';
import { useFormikContext } from 'formik';

const DisplayFormikState = () => {
  const { values } = useFormikContext();

  return (
    <div style={{ margin: '1rem 0' }}>
      <h3 style={{ fontFamily: 'monospace' }}>Formik State:</h3>
      <pre
        style={{
          background: '#f6f8fa',
          fontSize: '.75rem',
          padding: '.5rem',
        }}
      >
        {JSON.stringify(values, null, 2)}
      </pre>
    </div>
  );
};

export default DisplayFormikState;
